import React, { memo, useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import PropsTypes from 'prop-types';
import useDebouncedEffect from 'hooks/useDebounce';
import Pagination from 'components/Pagination';
import styles from 'styles/Profile.module.scss';
import { useRouter } from 'next/router';
import SearchPagination from '../Search/SearchPagination';
import { useTextSearch } from 'hooks/search';
import { formatQuery } from '../../helpers';
const FooterTableCustom = (props) => {
  const router = useRouter();
  const {
    pageCount,
    onChange,
    currentPage,
    showPagination,
    shouldUpdate,
    showInputSearch,
    changePath,
    isBusy,
    totalItems,
    currentItem,
    preventFirstLoad,
    learnerPage,
  } = props;
  const textSearch = useTextSearch();
  const [preventLoad, setPreventLoad] = useState(preventFirstLoad);
  useDebouncedEffect(
    () => {
      if (!preventLoad) {
        if (isBusy && parseInt(router?.query?.page) > 1) {
          fetchData(parseInt(router?.query?.page), textSearch?.trim());
        } else {
          fetchData(1, textSearch?.trim());
        }
      } else {
        setPreventLoad(false);
      }
    },
    500,
    [textSearch?.trim()],
  );

  async function fetchData(page, textSearch) {
    try {
      await onChange(page, textSearch);
      if (changePath) {
        const { pathname, query } = router;
        if (page > 1) {
          query.page = page;
        } else {
          delete query?.page;
        }
        if (textSearch) {
          query.textSearch = textSearch;
        } else {
          delete query?.textSearch;
        }
        const queryString = formatQuery(query);
        if (queryString) {
          router?.replace(pathname + '?' + queryString);
        } else {
          router?.replace(pathname);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handleChangePage(page) {
    if (props?.tabPage && page !== router.query?.page) {
      fetchData(page, textSearch);
    } else {
      fetchData(page, textSearch);
    }
  }

  useEffect(() => {
    if (shouldUpdate) {
      fetchData(currentPage, textSearch);
    }
  }, [shouldUpdate]);

  return (
    <>
      <hr className="mt-0" />
      <Row className="mx-md-2 mx-1 pb-0">
        <Col md={learnerPage ? 12 : 6} sm={learnerPage ? 12 : 6}>
          {showPagination && (
            <Pagination
              pageCount={pageCount}
              currentItem={currentItem}
              totalItems={totalItems}
              currentPage={currentPage}
              onChangePage={handleChangePage}
              learnerPage={learnerPage}
            />
          )}
        </Col>
        <Col md={6} sm={6}>
          <div className={`flexRow ${styles.wrap__course__tool}`}>
            {/* <Button.Ripple color="flat-secondary" className="px-05 py-05"> */}
            {/*  <Download /> */}
            {/* </Button.Ripple> */}
            {showInputSearch && <SearchPagination />}
          </div>
        </Col>
      </Row>
    </>
  );
};

FooterTableCustom.defaultProps = {
  showPagination: true,
  showInputSearch: true,
};

FooterTableCustom.prototype = {
  pageCount: PropsTypes.number,
  onChange: PropsTypes.func,
  currentPage: PropsTypes.number,
  shouldUpdate: PropsTypes.any,
  showInputSearch: PropsTypes.bool,
  changePath: PropsTypes.bool,
  currentItem: PropsTypes.number,
  totalItems: PropsTypes.number,
};

export default memo(FooterTableCustom);
